<template>
  <div
    v-if="props.isShow"
    class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center p-4 z-50"
  >
    <div class="confirm-dialog max-w-[512px] w-full shadow-lg rounded-md bg-white">
      <h3 class="ml-6 mt-7 mb-4">
        {{ t('messages.passkey.prompt.title') }}
      </h3>
      <p class="ml-6 mr-6 mb-5 text-zyxel-gray-800">
        {{ t('messages.passkey.prompt.description') }}
        <a
          class="inline-flex text-zyxel-green-700 cursor-pointer"
          :href="passkeyUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ $t('messages.passkey.prompt.link') }} <img
            class="h-5 ml-1"
            src="@/assets/svg/icon_20px_reopen.svg"
            alt="passkey link icon"
          >
        </a>
      </p>
      <div class="modal-footer hidden sm:flex justify-end">
        <button
          class="ml-3 mb-4 mr-4 button-primary min-w-[120px]"
          @click="handleOk"
        >
          {{ $t("messages.button.ok") }}
        </button>
      </div>
      <div class="modal-footer flex-col sm:hidden p-6">
        <button
          class="button-primary w-full mb-4"
          @click="handleOk"
        >
          {{ $t("messages.button.ok") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
import { useI18n } from 'vue-i18n';
import { apiBaseUrl } from '@/config.js';

const { t } = useI18n();

// 接收 prop
const props = defineProps({
  isShow: {
    type: Boolean,
    default: false
  }
});

const passkeyUrl = `${apiBaseUrl}/user/passkey`;

const emit = defineEmits(['ok']);

function handleOk() {
  emit('ok');
}
</script>